import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiError } from './client';

export function codiError(error: unknown): string {
  if (error instanceof ApiError) return error.codi;
  return 'error.desconegut';
}

export function campError(error: unknown): string | null {
  if (error instanceof ApiError && error.camp) return error.camp;
  return null;
}

export function useMissatgeError() {
  const { t } = useTranslation('errors');
  return useCallback(
    (error: unknown): string => {
      const opcions = { keySeparator: false as const };
      const codi = codiError(error);
      const perDefecte = t('error.desconegut', opcions);
      const missatge = t(codi, { ...opcions, defaultValue: perDefecte });
      const camp = campError(error);
      if (!camp) return missatge;
      const especific = t(`${codi}.${camp}`, { ...opcions, defaultValue: '' });
      if (especific) return especific;
      const nomCamp = t(`camp.${camp}`, { ...opcions, defaultValue: camp });
      return t('error.amb.camp', { ...opcions, missatge, camp: nomCamp });
    },
    [t],
  );
}
